import { ListFieldsOptionsApiCall } from "@/app/api/types";
import { FieldFilter } from "@/app/components/filters/FieldFilter";
import { fieldFilterApplied } from "@/app/fields/fieldFilterApplied";
import { Entity, IField } from "@/app/fields/types";
import { Accordion, AccordionItem, Box, Button } from "@chakra-ui/react";
import { useState } from "react";
import { useSearchParams } from "react-router";

export default function Filters<T extends Entity>({
  fields,
  getFieldOptions,
  onClearAllFilters,
  isDisabled,
}: {
  fields: IField<T>[];
  getFieldOptions: ListFieldsOptionsApiCall;
  onClearAllFilters: () => void;
  isDisabled: boolean;
}) {
  const filterFields = fields.filter(({ is_filter }) => is_filter);
  const [searchParams] = useSearchParams();
  const [accordionIndex, setAccordionIndex] = useState<number[]>(
    filterFields
      .map(({ field, type }) =>
        fieldFilterApplied(String(field), type, searchParams)
      )
      .map((applied, index) => (applied ? index : -1))
      .filter((applied) => applied > -1)
  );

  return (
    <div className="grow flex flex-col justify-between">
      <div className="overflow-scroll no-scrollbar">
        <Accordion
          data-cy="filters-accordion"
          allowMultiple={true}
          onChange={(updated: number[]) => setAccordionIndex(updated)}
          index={accordionIndex}
        >
          {filterFields.map((field) => (
            <AccordionItem key={String(field.field)}>
              {({ isExpanded }) => (
                <div
                  data-cy={`accordion-item-${String(field.field)}`}
                  data-expanded={`${isExpanded}`}
                >
                  <FieldFilter
                    isDisabled={isDisabled}
                    field={field}
                    getFieldOptions={getFieldOptions}
                  />
                </div>
              )}
            </AccordionItem>
          ))}
        </Accordion>
      </div>
      <Box mt={4} display="flex" flexDirection="column">
        <Button onClick={onClearAllFilters}>Clear all filters</Button>
      </Box>
    </div>
  );
}
